import { MagazineContentVariant } from '@pixum/magazine';

/**
 * Determines the magazine variant based on the given index.
 * We place this in the components since the index changed depends on the desktop
 * and mobile magazines
 *
 * This function alternates between `CONTENT_RIGHT` and `CONTENT_LEFT`
 * based on whether the index is even or odd.
 *
 * @param index - The index of the magazine item.
 * @returns Returns `CONTENT_RIGHT` for even indices, `CONTENT_LEFT` for odd indices.
 */
export function getMagazineVariant(index: number): MagazineContentVariant {
  return index % 2 === 0 ? MagazineContentVariant.CONTENT_RIGHT : MagazineContentVariant.CONTENT_LEFT;
}
